import React from 'react';
import _ from 'lodash';

import PetHOC from '../PetHOC';
import Bodies from './Bodies';
import Heads from './Heads';
import Eyes from './Eyes';
import Toy from '../../Goodies/Toy';

class Bear extends PetHOC {
	constructor(props) {
		super(props);
		this.actions = {
			idle: [
				{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: () => _.random(500, 4000),
					},
				},
				{
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: () => _.random(5000, 10000),
					},
				},
				{
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: () => _.random(200, 3000),
					},
					stop: {
						timeout: null,
						interval: () => 199,
					},
				},
				{
					name: 'wag',
					actions: ['isWaggingUp', 'isWaggingDown'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: () => 200,
					},
				},
				{
					name: 'sniff',
					actions: ['isSniffing'],
					start: {
						timeout: null,
						interval: () => _.random(1000, 10000),
					},
					stop: {
						timeout: null,
						interval: () => 150,
					},
				},
				{
					name: 'flapEar',
					actions: ['isFlappingEarRight', 'isFlappingEarLeft'],
					start: {
						timeout: null,
						interval: () => _.random(200, 8000),
					},
					stop: {
						timeout: null,
						interval: () => 200,
					},
				},
			],
			pet: [
				{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: () => _.random(600, 1200),
					},
				},
				{
					name: 'wag',
					actions: ['isWaggingUp', 'isWaggingDown'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: () => 100,
					},
				},
				{
					name: 'flapEars',
					actions: ['isFlappingEars'],
					start: {
						timeout: null,
						interval: () => _.random(200, 800),
					},
					stop: {
						timeout: null,
						interval: () => _.random(200, 800),
					},
				},
			],
		};
	}

	render() {
		return (
			<div className="pet-wrapper">
				<div
					className={this.getClassNames()}
					onMouseEnter={this.startBeingPet}
					onMouseLeave={this.stopBeingPet}>

					<img className="pet-frame" src={this.getFrameImagePathname()} alt="" />
					<div className="pet-name">{this.getName()}</div>
					<svg className="pet-shadow" viewBox="0 0 480 480">
						<ellipse cx="254" cy="366" rx="167" ry="33" />
					</svg>

					<div className="special-pet-transform-wrapper">
						<div className="pet-body-and-head">
							<svg className="pet__body" viewBox="0 0 480 480">
								<Bodies body={this.props.body} />
							</svg>
							<svg className="pet__head" viewBox="0 0 480 480">
								<Heads getHatTargetCoords={this.getHatTargetCoords} head={this.props.head} />
								<Eyes getGlassesTargetCoords={this.getGlassesTargetCoords} />
								{this.shouldRenderHat()}
								{this.shouldRenderGlasses()}
							</svg>
						</div>
					</div>

					<svg className="pet-toy" viewBox="0 0 480 480">
						<Toy toy={this.props.toy} />
					</svg>
				</div>
			</div>
		);
	}
}

export default Bear;



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Bear/index.js